import { DISPLAY_FUEL_TYPES } from '../../common/constants';

/**
 * Takes in a list of fuels and returns the fuel types that match the `DISPLAY_FUEL_TYPES` constant array
 * @param {*} fuelList The list of fuels to check against. Each fuel in this list must have a property `fuelType` with which the comparison is done against.
 * Note: if multiple of the same type are found in `fuelList`, only the first one is returned
 */
export default function getDisplayableFuels(fuelList) {
  return DISPLAY_FUEL_TYPES.map((fuelType) => {
    const fuelsOfType = fuelList.filter(f => f.displayName === fuelType);
    return fuelsOfType.length && fuelsOfType[0];
  }).filter(set => !!set);
}
